import { RoundedAudioPlayer } from "components/RoundedAudioPlayer";
import { VoicemailTableActions } from "routes/voicemail/components/voicemail_table/VoicemailTableActions";

export const getVoicemailTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original?.id}</p>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
    },
    {
      header: "File",
      id: "File",
      enableSorting: false,
      accessorKey: "attachment.url",
      size: 84,
      cell: ({ row }) => {
        const url = row.original?.attachment?.url;
        return url ? (
          <RoundedAudioPlayer
            id={`audio-el-${row.original?.id}`}
            src={url}
            showDuration
          />
        ) : null;
      },
    },
    {
      header: "Shared",
      id: "Shared",
      accessorKey: "is_shared",
      cell: ({ row }) => <p>{row.original?.is_shared ? "Yes" : "No"}</p>,
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => <VoicemailTableActions original={row.original} />,
    },
  ];
};
